import "./App.sass"
import { Route, Switch } from "react-router-dom"
import { Helmet, HelmetProvider } from "react-helmet-async"
// COMPONENTS
// import { AppFooter, AppHeader, Loading } from "./components"
// VIEWS
import { HomePage } from "./views"

// API
import { ThemeProvider, createTheme } from "@material-ui/core/styles"
import { useEffect } from "react"
//import { NavLink } from "react-router-dom"
import { __HEADERS_URL__ } from "./helpers"

const theme = createTheme({
  palette: {
    primary: {
      light: "#007ed9",
      main: "#006BB7",
      dark: "#004282",
      contrastText: "#fff"
    },
    secondary: {
      light: "#ff7961",
      main: "#61D19E",
      dark: "#ba000d",
      contrastText: "#000"
    }
  },
  typography: {
    fontFamily: [
      "Montserrat",
      "Roboto",
      "\"Helvetica Neue\"",
      "Arial",
      "sans-serif"
    ].join(",")
  }
})


const App = () => {
  useEffect(() => {
    (async () => {
      // Removed logout button
      let finish = false
      const maxRetries = 4
      let retry = 0
      while (!finish && retry <= maxRetries) {
        const logoutButton = document.querySelector("#logout")
        const logoutDropdownButton = document.querySelector("#logout-logout")
        if (logoutButton?.style) {
          finish = true
          logoutButton.style.display = "none"
        }
        if (logoutDropdownButton?.style) {
          finish = true
          logoutDropdownButton.style.display = "none"
        }
        await new Promise(resolve => setTimeout(resolve, 100))
        retry++
      }
    })()
  }, [])

  return (
    <HelmetProvider context={{}}>
      <div
        className="App-container"
        style={{ display: "flex", flexDirection: "column" }}>
        <div style={{ flexGrow: 1 }}>
          <Helmet>
            <link rel="stylesheet" href={`${__HEADERS_URL__}/index.css`} />
            <script type="text/javascript" src={`${__HEADERS_URL__}/index.js`}></script>
          </Helmet>
          <ThemeProvider theme={theme}>
            <Switch>
              <Route
                path="/" exact
                component={HomePage} />
            </Switch>
          </ThemeProvider>
        </div>
      </div>
    </HelmetProvider>
  )
}

export default App
